import ShareBase from "./share.base";
import { ShareResponse } from "./share.types";

export default class ShareWeb extends ShareBase {
  
  constructor() {
    super();
  }

  public override async share( data:ShareData ): Promise<ShareResponse> {
    try {
      if( !navigator.share ) {
        return { completed: false, error: 'Web Share API not available' };
      }

      const title = data.title;
      const text = data.text;
      let url: string | undefined = data.url;
      let files: [File] | undefined = undefined;

      if( url && url.startsWith('blob:') ) {
        const response = await fetch(url);
        if (response.ok) {
          const blob = await response.blob();
          if (blob.type.startsWith('video/')) {
            const videoFile = new File([blob], "video.mp4", { type: blob.type });
            files = [videoFile];
            url = undefined;
          }
        }      
      }

      await navigator.share({ title, text, url, files });

      return { completed: true };
    } catch (error) {
      if (error instanceof Error) {
        return { completed: false, error: error.message };
      } else {
        return { completed: false, error: String(error) };
      }
    }
  }
}